import { useState, useRef } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Button,
  Autocomplete,
  DataGrid,
  Checkbox,
  FormControlLabel,
} from "../../../../components";
import { ProdutosService, notification } from "../../../../services";
import {
  responseErros,
  formatPrice,
  timeoutBuscaAutocomplete,
} from "../../../../utils";
import { value } from "../../../../helpers";

const FormKitComponent = ({
  kitProdutos,
  setKitProdutos,
  inserirPrecosKit,
  produtoEntity,
  onChangeCheckbox,
}) => {
  const produtoService = new ProdutosService();
  const inputRef = useRef();
  const [listaProdutos, setListaProdutos] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [quantidade, setQuantidade] = useState(null);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);

  const produtosColunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 220,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 600,
    },
    {
      field: "quantidade",
      headerName: "Qtd",
      flex: 220,
    },
    {
      field: "estoqueAtual",
      headerName: "Estoque",
      flex: 220,
    },
    {
      field: "precoCompra",
      headerName: "Preço Compra",
      flex: 220,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "precoCusto",
      headerName: "Preço Custo",
      flex: 220,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 220,
      valueGetter: (params) => formatPrice(params.value),
    },
  ];

  const buscarProdutos = (filtros, isCodBar = false) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      limite: 20,
    };
    produtoService.getAllProdutosSimples(filtro).then((result) => {
      if (!result.isAxiosError) {
        setLoadingAutoComplete(false);
        const idsItemKit = kitProdutos.map(({ id }) => id);
        const produtos = result.data
          .filter((item) => !idsItemKit.includes(item.id))
          .map((item) => ({
            ...item,
            estoqueAtual: item.estoqueProduto.estoque,
            precoCompra: item.informacao?.precoCompra,
            precoCusto: item.informacao?.precoCusto,
            precoVenda: item.informacao?.precoVenda,
          }));
        setListaProdutos(produtos);
        if (result.data.length === 1 && isCodBar) {
          handleChangeAutocompleteProduto(result.data.rows[0]);
        }
      } else {
        setLoadingAutoComplete(false);
        responseErros(result);
      }
    });
  };

  const handleChangeAutocompleteProduto = (produtoEscolhido) => {
    setProdutoSelecionado(produtoEscolhido);
  };

  const onInputChangeProdutos = (event) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const eventValue = event.target.value;
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
        codigoBarra: eventValue,
        nonPaginated: true,
      };
      let isCodeBar = false;
      if (
        Number.isFinite(parseFloat(eventValue)) &&
        eventValue?.length >= 8 &&
        eventValue?.length <= 13
      ) {
        isCodeBar = true;
      }
      setLoadingAutoComplete(true);
      timeoutBuscaAutocomplete(buscarProdutos(filtros, isCodeBar));
    }
  };

  const handleAdicionarProduto = () => {
    if (!produtoSelecionado) {
      return notification.alertaGenericos(
        "Selecione um produto para adicionar"
      );
    }
    if (!quantidade) {
      return notification.alertaGenericos("Insira uma quantidade");
    }
    const produtoInserido = kitProdutos.find(
      (kitProduto) => kitProduto.idItemKit == produtoSelecionado.id
    );
    if (produtoInserido) {
      notification.alertaGenericos("Produto já inserido");
    } else {
      const addProdutosKit = [...kitProdutos, { ...produtoSelecionado, quantidade }];
      produtoEntity.addProdutosKitIds(produtoSelecionado.id, quantidade);
      setKitProdutos(addProdutosKit);
      inserirPrecosKit(addProdutosKit);
      setListaProdutos([]);
    }
    setQuantidade(null);
    setProdutoSelecionado(null);
  };

  const handleRemoverProduto = async (id) => {
    const produtoRemovido = kitProdutos.filter((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${produtoRemovido[0].descricao}?`
    );
    if (retornoAlerta.isConfirmed) {
      const produtosRestantes = kitProdutos.filter((item) => item.id !== id);
      produtoEntity.setProdutosKitIds(produtosRestantes);
      setKitProdutos(produtosRestantes);
      inserirPrecosKit(produtosRestantes);
    }
  };

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid className="mt-2" item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="envioKitItensFiscal"
                checked={produtoEntity?.envioKitItensFiscal}
                onChange={onChangeCheckbox}
              />
            }
            label="Envia itens do Kit para o DANFE"
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="produtoId"
              name="produtoId"
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText={"Digite e pressione Enter..."}
              options={listaProdutos}
              autoHighlight
              getOptionLabel={(option) =>
                `${option?.codigo} - ${option?.descricao}` ?? ""
              }
              filterSelectedOptions
              onChange={(_, newValue) =>
                handleChangeAutocompleteProduto(newValue)
              }
              value={produtoSelecionado}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Buscar produto"
                  inputRef={inputRef}
                  onKeyDown={onInputChangeProdutos}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextField
            id="quantidade"
            name="quantidade"
            label="Quantidade"
            variant="outlined"
            margin="normal"
            type="number"
            value={value.text(quantidade)}
            onChange={(e) => setQuantidade(parseFloat(e.target.value))}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            className="mt-2"
            size="large"
            variant="contained"
            color="primary"
            onClick={handleAdicionarProduto}
          >
            <i
              className="ph-fill ph-plus-circle"
              style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
            ></i>
            Adicionar ao KIT
          </Button>
        </Grid>
      </Grid>
      <Grid className="mt-1" container spacing={4}>
        <Grid item xs={12}>
          <DataGrid
            rows={kitProdutos}
            columns={produtosColunas}
            rowCount={kitProdutos.length}
            deleteShow
            onClickDelete={handleRemoverProduto}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormKitComponent;
